<template>
  <div class="w-full">
    <label v-if="label" :for="inputId" class="text-label block mb-1.5">
      {{ label }}
      <span v-if="required" class="text-danger ml-0.5" aria-hidden="true">*</span>
    </label>
    <p v-if="description" class="text-caption mb-2">{{ description }}</p>
    <input
      :id="inputId"
      :value="modelValue"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :class="inputClasses"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <p v-if="error" class="text-sm text-danger mt-1.5" role="alert">{{ error }}</p>
    <p v-else-if="hint" class="text-caption mt-1.5">{{ hint }}</p>
  </div>
</template>

<script>
let idCounter = 0

export default {
  name: 'BaseInput',
  inheritAttrs: false,
  props: {
    modelValue: { type: [String, Number], default: '' },
    label: String,
    description: String,
    hint: String,
    error: String,
    type: { type: String, default: 'text' },
    placeholder: String,
    disabled: Boolean,
    required: Boolean,
    autofocus: Boolean,
  },
  emits: ['update:modelValue'],
  data() {
    return { inputId: `input-${++idCounter}` }
  },
  computed: {
    inputClasses() {
      return [
        'w-full rounded-lg border px-4 py-2.5 text-sm text-foreground placeholder:text-muted transition-colors duration-200 glass-input',
        'focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        this.error ? 'border-danger' : 'border-white/50 dark:border-white/10',
      ]
    },
  },
}
</script>
